import styled from "styled-components";

export const StyledWrapper = styled.div`
  max-width: 2000px;
  height: 100%;
`;

export const StyledTextDivBold = styled.div`
  text-align: left;
  font-weight: bold;
`;

export const StyledTextDiv = styled.div`
  text-align: left;
  margin-bottom: 1em;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  align-items: flex-start;
`;
